import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { UserIcon, PhoneIcon, EmailIcon } from './Icons';
import './Team.css';

const Team = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const teamMembers = [
    {
      name: language === 'ar' ? 'المدير التنفيذي' : 'Executive Director',
      role: t.executiveDirectorName,
      phone: '+249 912 797 684',
      email: 'info@mandula.org'
    },
    {
      name: language === 'ar' ? 'منسق البرامج' : 'Program Coordinator',
      role: t.programCoordinator,
      phone: '+249 129 552 787',
      email: 'info@mandula.org'
    }
  ];

  return (
    <section id="team" className="team">
      <div className="container">
        <div className="section-header">
          <h2>{t.teamTitle}</h2>
          <p>{t.teamIntro}</p>
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <div className="team-icon">
                <UserIcon />
              </div>
              <h3>{member.name}</h3>
              <p className="team-role">{member.role}</p>
              <div className="team-contact">
                <div className="contact-row">
                  <PhoneIcon />
                  <span>{member.phone}</span>
                </div>
                <div className="contact-row">
                  <EmailIcon />
                  <span>{member.email}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
